import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 24457 30014"
    {...props}
  >
    <path
      d="M5881 3562v8322h12695V3562c0-1183 270-2075 804-2670 535-595 1238-892 2109-892 879 0 1596 291 2143 879 548 588 825 1480 825 2683v22869c0 1203-277 2095-831 2690-555 595-1271 893-2137 893-885 0-1595-298-2122-899-527-602-791-1494-791-2684v-9761H5881v9761c0 1203-277 2095-831 2690-555 595-1271 893-2136 893-886 0-1596-298-2123-899-527-602-791-1494-791-2684V3562C0 2373 264 1487 784 892 1305 297 2014 0 2914 0c878 0 1595 291 2142 879 548 588 825 1487 825 2683z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
